import angular from 'angular';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import filter from 'lodash/filter';

class DividersService {
    constructor(config, internalSashesService, windowDimensionsService) {
        this.config = config;
        this.internalSashesService = internalSashesService;
        this.windowDimensionsService = windowDimensionsService;
        this.dividers = [];
        this.initialDividersData = [];
    }

    addAdjacentSash(divider, adjacentDividerId, direction) {
        if (divider && divider.adjacentSashes[direction].indexOf(adjacentDividerId) < 0) {
            divider.adjacentSashes[direction].push(adjacentDividerId);
        }
    }

    addAdjacentDividersToBottomDivider(bottomDivider, currentSash) {
        const divider = bottomDivider;
        const isSplitHorDiv = this.windowDimensionsService.isSplitHorDiv;

        forEach(currentSash.intDividers, (el, index) => {
            if (el.direction === 'vertical' && isSplitHorDiv) {
                divider.adjacentDividers.top.push(el.id);
            } else if (el.direction === 'vertical' && !isSplitHorDiv) {
                const horizontalDividersLength = this.getSashDividers('horizontal').length;
                const newIndex = index - horizontalDividersLength;

                if (newIndex % (horizontalDividersLength + 1) === horizontalDividersLength) {
                    divider.adjacentDividers.top.push(el.id);
                }
            }
        });
    }

    addAdjacentSashesToBottomDivider(bottomDivider, currentSash) {
        const bottomIntSashes = filter(currentSash.intSashes,
            el => el.nearDividers.bottom === -1
        );

        forEach(bottomIntSashes, (el) => {
            const currentIntSash = el;

            currentIntSash.nearDividers.bottom = bottomDivider.id;
            if (bottomDivider.adjacentSashes.top.indexOf(currentIntSash.id) === -1) {
                bottomDivider.adjacentSashes.top.push(currentIntSash.id);
            }
        });
    }

    addHorizontalIntDivider(currentSash, newDividerId) {
        const verticalDividers = filter(currentSash.intDividers, ['direction', 'vertical']);
        const max = verticalDividers.length + 1;
        let dividerId = newDividerId;

        for (let i = 0; i < max; i++) {
            const newDivider = this.createNewDivider('horizontal');
            const newIntSash = this.internalSashesService.createNewIntSash(currentSash);

            newDivider.id = dividerId;

            const allSashes = currentSash.intSashes;
            const allDividers = currentSash.intDividers;

            const idUp = (allSashes[allSashes.length - max].id);
            newIntSash.nearDividers = cloneDeep(allSashes[idUp].nearDividers);
            allSashes[idUp].nearDividers.bottom = newDivider.id;
            newDivider.adjacentSashes.top.push(allSashes[idUp].id);
            newIntSash.nearDividers.top = newDivider.id;
            newDivider.adjacentSashes.bottom.push(newIntSash.id);
            currentSash.intSashes.push(cloneDeep(newIntSash));

            if (newIntSash.nearDividers.left !== -1) {
                const leftDiv = find(allDividers, ['id', newIntSash.nearDividers.left]);
                leftDiv.adjacentSashes.right.push(newIntSash.id);
            }
            if (newIntSash.nearDividers.right !== -1) {
                const rightDiv = find(allDividers, ['id', newIntSash.nearDividers.right]);
                rightDiv.adjacentSashes.left.push(newIntSash.id);
            }

            currentSash.intDividers.push(cloneDeep(newDivider));
            dividerId++;
        }
    }

    addVerticalIntDivider(currentSash, newDividerId) {
        const horizontalDividers = filter(currentSash.intDividers, ['direction', 'horizontal']);
        const max = horizontalDividers.length + 1;
        let dividerId = newDividerId;

        for (let i = 0; i < max; ++i) {
            const newDivider = this.createNewDivider('vertical');
            const newIntSash = this.internalSashesService.createNewIntSash(currentSash);

            newDivider.id = dividerId;

            const allSashes = currentSash.intSashes;
            const allDividers = currentSash.intDividers;

            const idLeft = (allSashes[allSashes.length - max].id);
            newIntSash.nearDividers = cloneDeep(allSashes[idLeft].nearDividers);
            allSashes[idLeft].nearDividers.right = newDivider.id;
            newDivider.adjacentSashes.left.push(allSashes[idLeft].id);
            newIntSash.nearDividers.left = newDivider.id;
            newDivider.adjacentSashes.right.push(newIntSash.id);
            currentSash.intSashes.push(cloneDeep(newIntSash));

            if (newIntSash.nearDividers.top !== -1) {
                const bottomDiv = find(allDividers, ['id', newIntSash.nearDividers.top]);
                bottomDiv.adjacentSashes.bottom.push(newIntSash.id);
            }
            if (newIntSash.nearDividers.bottom !== -1) {
                const topDiv = find(allDividers, ['id', newIntSash.nearDividers.bottom]);
                topDiv.adjacentSashes.top.push(newIntSash.id);
            }

            dividerId++;
            currentSash.intDividers.push(cloneDeep(newDivider));
        }
    }

    createDividerAboveBottomPannel(parentSash) {
        const newDivider = this.createNewDivider('horizontal');
        const dividerAboveBottomPannel = {
            id: this.getNewDividerId(),
            length: parentSash.width,
            position: this.windowDimensionsService.getBottomPannel(),
            dividerId: this.config.jsonConfig.bottomPannelDividerId,
        };

        return Object.assign(newDivider, dividerAboveBottomPannel);
    }

    createNewDivider(direction) {
        const newDivider = {
            dividerId: this.config.jsonConfig.dividerId,
            direction,
            adjacentSashes: {},
            adjacentDividers: {},
            profileId: '13',
        };

        let neighbours = {
            top: [],
            bottom: []
        };

        if (direction === 'vertical') {
            neighbours = {
                left: [],
                right: []
            };
        }

        newDivider.adjacentSashes = cloneDeep(neighbours);
        newDivider.adjacentDividers = cloneDeep(neighbours);

        return newDivider;
    }

    getDivider(id) {
        return find(this.dividers, el => el.id === id);
    }

    getDividersJson() {
        return this.dividers;
    }

    getNewDividerId(sashesJson) {
        let newId = -1;

        forEach(this.dividers, (el) => {
            if (el.id > newId) {
                newId = el.id;
            }
        });

        forEach(sashesJson, (el) => {
            forEach(el.intDividers, (el1) => {
                if (el1.id > newId) {
                    newId = el1.id;
                }
            });
        });

        return ++newId;
    }

    pushDivider(divider) {
        this.dividers.push(divider);
    }

    resetDividers() {
        this.dividers = cloneDeep(this.initialDividersData);

        forEach(this.dividers, (divider, key) => {
            if (angular.isUndefined(this.dividers[key].adjacentSashes)) {
                this.dividers[key].adjacentSashes = {
                    left: [],
                    right: [],
                };
            }
        });
    }

    setDimension(currentDivider, index, sash, sashIndex) {
        const divider = currentDivider;
        const length = this.windowDimensionsService.getIntDividerLength(divider.direction, sash);
        let position;
        const newIndex = this.windowDimensionsService.convertIntSashIndex(
            index,
            divider.direction,
            this.windowDimensionsService.getVerticalDividersLength() + 1,
            this.windowDimensionsService.getHorizontalDividersLength() + 1
        );

        if (currentDivider.direction === 'vertical') {
            position = this.windowDimensionsService.getSashWidth(sashIndex) /
                (this.windowDimensionsService.verticalDividersLength + 1);
        } else {
            position = this.windowDimensionsService.getSashHeight(
                sashIndex,
                this.windowDimensionsService.isBottomPannel()
            ) / (this.windowDimensionsService.getHorizontalDividersLength() + 1);
        }

        divider.length = length;
        divider.position = (newIndex + 1) * position;
    }

    setNewApiId(apiId) {
        forEach(this.dividers, (el) => {
            const currentDivider = el;
            currentDivider.dividerId = apiId;
        });

        forEach(this.initialDividersData, (el) => {
            const currentDivider = el;
            currentDivider.dividerId = apiId;
        });
    }

    setInitialData(jsonObject) {
        this.dividers = jsonObject.dividers;
        this.initialDividersData = cloneDeep(jsonObject.dividers);
    }

    updateAdjacentDividers(sash) {
        const isSplitHorDiv = this.windowDimensionsService.isSplitHorDiv;
        const intDividers = sash.intDividers;
        let currentDivider;

        forEach(sash.intSashes, (el1) => {
            if (isSplitHorDiv && el1.nearDividers.bottom !== -1 && el1.nearDividers.right !== -1) {
                currentDivider = find(intDividers, ['id', el1.nearDividers.right]);
                if (currentDivider.adjacentDividers.left.indexOf(el1.nearDividers.bottom) < 0) {
                    currentDivider.adjacentDividers.left.push(el1.nearDividers.bottom);
                }
            }
            if (isSplitHorDiv && el1.nearDividers.bottom !== -1 && el1.nearDividers.left !== -1) {
                currentDivider = find(intDividers, ['id', el1.nearDividers.left]);
                if (currentDivider.adjacentDividers.right.indexOf(el1.nearDividers.bottom) < 0) {
                    currentDivider.adjacentDividers.right.push(el1.nearDividers.bottom);
                }
            }
            if (!isSplitHorDiv && el1.nearDividers.right !== -1 && el1.nearDividers.bottom !== -1) {
                currentDivider = find(intDividers, ['id', el1.nearDividers.bottom]);

                if (currentDivider.adjacentDividers.top.indexOf(el1.nearDividers.right) < 0) {
                    currentDivider.adjacentDividers.top.push(el1.nearDividers.right);
                }
            }
            if (!isSplitHorDiv && el1.nearDividers.right !== -1 && el1.nearDividers.top !== -1) {
                currentDivider = find(intDividers, ['id', el1.nearDividers.top]);
                if (currentDivider.adjacentDividers.bottom.indexOf(el1.nearDividers.right) < 0) {
                    currentDivider.adjacentDividers.bottom.push(el1.nearDividers.right);
                }
            }
        });
    }

    updateAdjacentDividersDimensions(sash) {
        const currentSash = sash;
        const nearDividers = currentSash.nearDividers;
        let divider;

        if (nearDividers.bottom !== -1) {
            divider = this.getDivider(nearDividers.bottom);
            if (!divider) {
                return;
            }
            divider.length = currentSash.width;
            divider.position = currentSash.y + currentSash.height;
        }
        if (nearDividers.right !== -1) {
            divider = this.getDivider(nearDividers.right);
            if (!divider) {
                return;
            }
            divider.length = currentSash.height *
                (this.windowDimensionsService.getHorizontalDividersLength() + 1);
            divider.position = currentSash.x + currentSash.width;
        }
    }

    updateWindowDivider(divider, index, leftSash) {
        const currentDivider = divider;
        if (divider.direction === 'vertical') {
            currentDivider.length = leftSash.height;
            currentDivider.position = leftSash.x + leftSash.width;
        } else {
            currentDivider.length = this.windowDimensionsService.width;
            currentDivider.position = this.windowDimensionsService.getSashHeight(0);
        }

        if (divider.direction === 'vertical' && leftSash.type.type === 'F') {
            currentDivider.length = leftSash.height *
                (this.windowDimensionsService.getHorizontalDividersLength() + 1);
            if (this.windowDimensionsService.isBottomPannel()) {
                currentDivider.length = this.windowDimensionsService.getSashHeight();
            }
        }
    }

    updateWindowDividersDimensions(sashes) {
        const topLightFields = this.windowDimensionsService.getTopLightFields();
        const standardFields = this.windowDimensionsService.getStandardFields();
        const max = (standardFields - 1) + topLightFields;
        forEach(this.dividers, (el, index) => {
            if (index < max) {
                let leftSash = null;
                if (el.direction === 'vertical') {
                    leftSash = find(sashes, el1 => el1.id === el.adjacentSashes.left[0]);
                }

                this.updateWindowDivider(el, index, leftSash);
            }
        });
    }
}

DividersService.$inject = ['config', 'internalSashesService', 'windowDimensionsService'];

export default angular.module('dividersService', [])
    .service('dividersService', DividersService)
    .name;